import { userAdapter } from '@skop-app/lib-domain/adapters'
import type { UserSchema, UserTeamsSchema } from '@skop-app/lib-domain/types'
import type { SeatAwareUserTeam } from '@/types/seatAccess'

// Retain server-owned seat outcomes alongside the shared user projection.
export function seatAwareUserAdapter(user: UserSchema) {
  const adapted = userAdapter(user)
  const memberships = user.organizations.items as (UserTeamsSchema &
    Pick<SeatAwareUserTeam, 'onSeat' | 'seatAccessState' | 'seatGraceEndsAt'>)[]
  return {
    ...adapted,
    organizations: adapted.organizations.map(
      (organization): SeatAwareUserTeam => {
        const membership = memberships.find(({ id }) => id === organization.id)
        return {
          ...organization,
          onSeat: membership?.onSeat,
          seatAccessState: membership?.seatAccessState,
          seatGraceEndsAt: membership?.seatGraceEndsAt,
        }
      },
    ),
  }
}
